const KEYS = ['authToken', 'authenticated', 'user'];

export function getAuthToken() {
  return localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
}

export function isAuthFlagSet() {
  return (
    localStorage.getItem('authenticated') === 'true' ||
    sessionStorage.getItem('authenticated') === 'true'
  );
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setStoredUser(user) {
  const target = localStorage.getItem('authToken') ? localStorage : sessionStorage;
  try { target.setItem('user', JSON.stringify(user)); } catch {}
}

export function setAuth({ token, user, remember = true }) {
  const store = remember ? localStorage : sessionStorage;
  const other = remember ? sessionStorage : localStorage;
  if (token) store.setItem('authToken', token);
  store.setItem('authenticated', 'true');
  if (user) {
    try { store.setItem('user', JSON.stringify(user)); } catch {}
  }
  for (const k of KEYS) other.removeItem(k);
}

export function markAuthenticated(remember = true) {
  const store = remember ? localStorage : sessionStorage;
  store.setItem('authenticated', 'true');
}

export function clearAuth() {
  for (const k of KEYS) {
    localStorage.removeItem(k);
    sessionStorage.removeItem(k);
  }
}

// Post-login deep-link handoff. A page that bounces an unauthenticated
// visitor through login (invite links, the marketing-site modal) stores
// the path it wants the user back at; the login/verify pages consume it
// here after auth succeeds. Only same-origin paths are honoured — a
// poisoned redirect value must not be able to push the user off-host.
// One implementation: LoginPage and VerifyEmailPage carried identical
// copy-pasted allowlist blocks before this.
export function consumePostLoginRedirect() {
  let target = '/';
  try {
    const stored = localStorage.getItem('pidly.postLoginRedirect');
    if (stored && stored.startsWith('/') && !stored.startsWith('//')) {
      target = stored;
    }
    localStorage.removeItem('pidly.postLoginRedirect');
  } catch { /* storage unavailable — plain "/" */ }
  return target;
}

// Was the last sign-out caused by the inactivity timeout? Reading this
// CONSUMES the flag (App.jsx's useSessionTimeout handler sets it just
// before bouncing to /login), so the notice shows once and doesn't
// linger into the next manual visit to the login page.
export function consumeSignedOutByTimeout() {
  try {
    if (sessionStorage.getItem('pidly.signedOutByTimeout')) {
      sessionStorage.removeItem('pidly.signedOutByTimeout');
      return true;
    }
  } catch { /* storage unavailable — no notice */ }
  return false;
}

// Decode the JWT's exp claim and check if it's past. Returns false for
// missing/non-JWT tokens (including the 'local-dev' bypass) and for any
// parse error — in those cases we fall through and let the server's 401
// be the source of truth.
export function isTokenExpired() {
  const token = getAuthToken();
  if (!token || token === 'local-dev') return false;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    if (typeof payload.exp !== 'number') return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return false;
  }
}
